// Full navigation model used by the mega-menu.
export const NAV = [
  {
    id: "who-we-serve",
    label: "Who We Serve",
    to: "/industries",
    panel: {
      kind: "columns",
      columns: [
        { items: [
          { title: "Logistics & transportation", desc: "Dispatch, tracking and delivery software", to: "/industries/logistics-transportation-in-oman" },
          { title: "Retail & e-commerce", desc: "Marketplaces, stores and the operations behind them", to: "/industries/retail-e-commerce-in-oman" },
          { title: "Government & public sector", desc: "Bilingual, auditable systems", to: "/industries/government-public-sector-oman" },
          { title: "Banking & financial services", desc: "Portals, onboarding and risk", to: "/industries/banking-financial-services-oman" },
          { title: "Healthcare", desc: "Patient systems built for sensitive-data rules", to: "/industries/healthcare-in-oman" },
        ] },
        { items: [
          { title: "Real estate & facilities", desc: "Property CRM, community and maintenance apps", to: "/industries/real-estate-facilities-oman" },
          { title: "Education", desc: "Admissions, learning and parent communication", to: "/industries/education-in-oman" },
          { title: "Manufacturing & distribution", desc: "Production, quality and dealer portals", to: "/industries/manufacturing-distribution-oman" },
          { title: "Automotive", desc: "Showroom, inventory, leads and service", to: "/industries/automotive-in-oman" },
        ] },
      ],
      viewAll: { label: "View all industries", to: "/industries" },
    },
  },

  {
    id: "services", label: "Services", to: "/services",
    panel: {
      kind: "columns",
      columns: [
        { heading: "Build", items: [
          { title: "Custom software development", to: "/services/custom-software-development-company-in-oman" },
          { title: "SaaS development", to: "/services/saas-development-company-in-oman" },
          { title: "Enterprise software", to: "/services/enterprise-software-development-company-in-oman" },
          { title: "Mobile app development", to: "/services/mobile-app-development-company-in-oman" },
          { title: "Web design & development", to: "/services/web-design-company-in-oman" },
          { title: "CRM development", to: "/services/crm-software-development-company-in-oman" },
          { title: "ERP & HRMS", to: "/services/erp-software-development-company-in-oman" },
          { title: "MVP development", to: "/services/custom-software-development-company-in-oman" },
        ] },
        { heading: "Intelligence", items: [
          { title: "AI Lab", to: "/ai-lab" },
          { title: "Conversational AI", to: "/ai-lab" },
          { title: "Document intelligence", to: "/ai-lab" },
          { title: "AI copilots", to: "/ai-lab" },
          { title: "Agentic workflows", to: "/ai-lab" },
          { title: "Predictive models", to: "/ai-lab" },
        ] },
        { heading: "Secure", items: [
          { title: "Meyar Enterprise GRC", to: "/meyar/enterprise-grc" },
          { title: "Meyar Cyber Security GRC", to: "/meyar/cyber-security-grc" },
          { title: "PDPL compliance", to: "/pdpl-compliance" },
        ] },
        { heading: "Run & Grow", items: [
          { title: "Application support & maintenance", to: "/services/application-support-maintenance-oman" },
          { title: "QA & testing", to: "/services/application-support-maintenance-oman" },
          { title: "Cloud, DevOps & data residency", to: "/services/cloud-devops-oman" },
          { title: "Software modernisation", to: "/services/application-support-maintenance-oman" },
          { title: "SEO", to: "/services/digital-marketing-company-in-oman" },
          { title: "PPC", to: "/services/digital-marketing-company-in-oman" },
          { title: "Social media", to: "/services/digital-marketing-company-in-oman" },
        ] },
      ],
      viewAll: { label: "View all services", to: "/services" },
    },
  },

  {
    id: "solutions", label: "Solutions", to: "/solutions",
    panel: {
      kind: "columns",
      columns: [
        { items: [
          { title: "On-demand delivery platform", desc: "Customer app, driver app, dispatch and shipper portal", to: "/solutions/on-demand-delivery-platform" },
          { title: "Logistics & fleet software", desc: "Routes, fleet, rate cards and invoicing", to: "/solutions/logistics-fleet-software" },
          { title: "Warehouse management", desc: "Receiving to dispatch, bin-level accuracy", to: "/solutions/warehouse-management" },
          { title: "E-commerce marketplace", desc: "Vendors, commissions, split orders and payouts", to: "/solutions/e-commerce-marketplace" },
        ] },
        { items: [
          { title: "Showroom management", desc: "Vehicle inventory, leads and public listings", to: "/solutions/showroom-management" },
          { title: "Community & building app", desc: "Access, visitors, maintenance and payments", to: "/solutions/community-building-app" },
          { title: "Shipploy", desc: "Deploy from Git, no DevOps team required", to: "/solutions/shipploy" },
          { title: "Leadaro", desc: "Verified B2B leads with AI outreach agents", to: "/solutions/leadaro" },
        ] },
      ],
      viewAll: { label: "View all solutions", to: "/solutions" },
    },
  },

  {
    id: "meyar", label: "Meyar", to: "/meyar",
    panel: {
      kind: "columns-with-promo",
      columns: [{ items: [
        { title: "Meyar overview", desc: "One GRC platform, two product lines", to: "/meyar" },
        { title: "Meyar Enterprise GRC", desc: "Enterprise risk, policy, audit and board reporting", to: "/meyar/enterprise-grc" },
        { title: "Meyar Cyber Security GRC", desc: "ISO 27001 and NIST control governance", to: "/meyar/cyber-security-grc" },
      ] }],
      promo: { title: "AI on every risk.", line: "See a 20-minute demo.", cta: { label: "Book a demo", to: "/contact" } },
    },
  },

  {
    id: "tools", label: "Tools", to: "/tools", isNew: true,
    panel: {
      kind: "columns",
      columns: [
        { items: [
          { title: "PDPL Readiness Check", desc: "Score your compliance in 3 minutes", to: "/tools/pdpl-readiness-check" },
          { title: "ISO 27001 Readiness Score", desc: "See how close you are to certification", to: "/tools/iso-27001-readiness" },
        ] },
        { items: [
          { title: "Software Cost Estimator", desc: "Indicative cost band in Omani Rials", to: "/tools/software-cost-estimator" },
          { title: "AI Opportunity Finder", desc: "Three AI use cases for your industry", to: "/tools/ai-opportunity-finder" },
        ] },
      ],
      viewAll: { label: "View all tools", to: "/tools" },
    },
  },

  { id: "work", label: "Work", to: "/work" },

  {
    id: "company", label: "Company", to: "/company",
    panel: {
      kind: "columns-with-promo",
      columns: [{ items: [
        { title: "About us", to: "/about" },
        { title: "How we work", to: "/how-we-work" },
        { title: "PDPL & compliance", to: "/pdpl-compliance" },
        { title: "Blog", to: "/blog" },
        { title: "Podcast", to: "/podcast" },
        { title: "Careers", to: "/careers" },
        { title: "Contact", to: "/contact" },
      ] }],
      promo: { variant: "team", title: "A note from the team", line: "Why we built Wafa, and how we run the platforms we ship.", cta: { label: "Read the note", to: "/company/about-us" } },
    },
    // Note: sub-links updated below to new /company/* paths.
  },
];
